import { observeHomeSnapshotInvalidation } from './pages/home/homeSnapshot';
import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

observeHomeSnapshotInvalidation(queryClient);
export default queryClient;
